import { Controller } from "@hotwired/stimulus"

// Toggle behavior for the BD payment "Soutenez Kube" tip chips. Clicking a
// chip selects it (or deselects if already on); writes the cents value into
// the hidden input and dispatches `change` so form-autosubmit submits.
export default class extends Controller {
  static targets = ["button", "input"]
  static values = { current: Number }

  pick(event) {
    const cents = Number(event.currentTarget.dataset.tipCents)
    const next = (this.currentValue === cents) ? 0 : cents
    this.currentValue = next
    this.buttonTargets.forEach(b => {
      b.classList.toggle("is-selected", Number(b.dataset.tipCents) === next)
    })
    if (this.hasInputTarget) {
      this.inputTarget.value = next
      this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }
}
